import {
    SET_REQUESTS_GRID_FILTERS,
    SET_ASSET_GRID_FILTERS,
    SET_HOME_PENDING_APPROVAL_GRID_FILTERS,
    SET_HOME_MY_ORDERS_GRID_FILTERS,
    SET_HOME_FLEET_PROCESSING_GRID_FILTERS,
    SET_ALL_PENDING_APPROVAL_GRID_FILTERS,
    SET_BULK_ORDER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_GRID_FILTERS,
    SET_REQUEST_TOTAL_ORDER_FILTERS,
    SET_REQUEST_PENDING_APPROVAL_FILTERS,
    SET_REQUEST_FLEET_PROCESSING_FILTERS,
    SET_REQUEST_COMPLETED_FILTERS,
    SET_REQUEST_RETURNED_FILTERS,
    SET_REQUEST_PENDING_FLEET_FILTERS,
    SET_REQUEST_REJECTED_FILTERS,
    SET_REQUEST_CANCELLED_FILTERS,
    SET_DISPOSITION_PENALTY_FEES_FILTERS,
    SET_ASSET_TOTAL_ORDER_FILTERS,
    SET_ASSET_PENDING_APPROVAL_FILTERS,
    SET_ASSET_FLEET_PROCESSING_FILTERS,
    SET_ASSET_COMPLETED_FILTERS,
    SET_ASSET_RETURNED_FILTERS,
    SET_ASSET_PENDING_FLEET_FILTERS,
    SET_ASSET_REJECTED_FILTERS,
    SET_ASSET_CANCELLED_FILTERS,
    SET_BULK_ORDER_PENDING_APPROVAL_FILTERS,
    SET_BULK_ORDER_TOTAL_ORDER_FILTERS,
    SET_BULK_ORDER_FLEET_PROCESSING_FILTERS,
    SET_BULK_ORDER_COMPLETED_FILTERS,
    SET_BULK_ORDER_RETURNED_FILTERS,
    SET_BULK_ORDER_REJECTED_FILTERS,
    SET_BULK_ORDER_CANCELLED_FILTERS,
    SET_ACQUISITION_CODE_MAINTENANCE_FILTERS,
    SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS,
    SET_REQUEST_SAVED_ORDER_FILTERS,
    SET_ASSET_SAVED_ORDER_FILTERS,
    SET_BULK_ORDER_SAVED_ORDER_FILTERS,
    SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS
} from "./GridDataFiltersType"

const setRequestGridFilters = (requestFilters: any) => ({
    type: SET_REQUESTS_GRID_FILTERS,
    requestFilters
})

const setAssetGridFilters = (assetFilters: any) => ({
    type: SET_ASSET_GRID_FILTERS,
    assetFilters
})

const setHomePendingApprovalGridFilters = (pendingApprovalFilters: any) => ({
    type: SET_HOME_PENDING_APPROVAL_GRID_FILTERS,
    pendingApprovalFilters
})

const setHomeMyOrdersGridFilters = (myOrdersFilters: any) => ({
    type: SET_HOME_MY_ORDERS_GRID_FILTERS,
    myOrdersFilters
})

const setHomeFleetProcessingGridFilters = (fleetFilters: any) => ({
    type: SET_HOME_FLEET_PROCESSING_GRID_FILTERS,
    fleetFilters
})

const setHomeAllPendingApprovalGridFilters = (allPendingApprovalFilters: any) => ({
    type: SET_ALL_PENDING_APPROVAL_GRID_FILTERS,
    allPendingApprovalFilters
})

const setBulkOrderGridFilters = (bulkOrderFilters: any) => ({
    type: SET_BULK_ORDER_GRID_FILTERS,
    bulkOrderFilters
})

const setCatalogManagementGridFilters = (catalogManagementFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_GRID_FILTERS,
    catalogManagementFilters
})

const setRequestTotalOrderFilters = (requestTotalOrderFilters: any) => ({
    type: SET_REQUEST_TOTAL_ORDER_FILTERS,
    requestTotalOrderFilters
})

const setRequestSavedOrderFilters = (requestSavedOrderFilters: any) => ({
    type: SET_REQUEST_SAVED_ORDER_FILTERS,
    requestSavedOrderFilters
})

const setRequestPendingApprovalFilters = (requestPendingApprovalFilters: any) => ({
    type: SET_REQUEST_PENDING_APPROVAL_FILTERS,
    requestPendingApprovalFilters
})

const setRequestFleetProcessingFilters = (requestFleetProcessingFilters: any) => ({
    type: SET_REQUEST_FLEET_PROCESSING_FILTERS,
    requestFleetProcessingFilters
})

const setRequestCompletedFilters = (requestCompletedFilters: any) => ({
    type: SET_REQUEST_COMPLETED_FILTERS,
    requestCompletedFilters
})

const setRequestReturnedFilters = (requestRetuernedFilters: any) => ({
    type: SET_REQUEST_RETURNED_FILTERS,
    requestRetuernedFilters
})

const setRequestPendingFleetFilters = (requestPendingFleetFilters: any) => ({
    type: SET_REQUEST_PENDING_FLEET_FILTERS,
    requestPendingFleetFilters
})

const setRequestRejectedFilters = (requestRejectedFilters: any) => ({
    type: SET_REQUEST_REJECTED_FILTERS,
    requestRejectedFilters
})

const setRequestCancelledFilters = (requestCancelledFilters: any) => ({
    type: SET_REQUEST_CANCELLED_FILTERS,
    requestCancelledFilters
})

const setDispositionPenaltyFeesFilters = (dispositionPenaltyFeesFilters: any) => ({
    type: SET_DISPOSITION_PENALTY_FEES_FILTERS,
    dispositionPenaltyFeesFilters
})

const setAssetTotalOrderFilters = (assetTotalOrderFilters: any) => ({
    type: SET_ASSET_TOTAL_ORDER_FILTERS,
    assetTotalOrderFilters
})

const setAssetSavedOrderFilters = (assetSavedOrderFilters: any) => ({
    type: SET_ASSET_SAVED_ORDER_FILTERS,
    assetSavedOrderFilters
})


const setAssetPendingApprovalFilters = (assetPendingApprovalFilters: any) => ({
    type: SET_ASSET_PENDING_APPROVAL_FILTERS,
    assetPendingApprovalFilters
})

const setAssetFleetProcessingFilters = (assetFleetProcessingFilters: any) => ({
    type: SET_ASSET_FLEET_PROCESSING_FILTERS,
    assetFleetProcessingFilters
})

const setAssetCompletedFilters = (assetCompletedFilters: any) => ({
    type: SET_ASSET_COMPLETED_FILTERS,
    assetCompletedFilters
})

const setAssetReturnedFilters = (assetRetuernedFilters: any) => ({
    type: SET_ASSET_RETURNED_FILTERS,
    assetRetuernedFilters
})

const setAssetPendingFleetFilters = (assetPendingFleetFilters: any) => ({
    type: SET_ASSET_PENDING_FLEET_FILTERS,
    assetPendingFleetFilters
})

const setAssetRejectedFilters = (assetRejectedFilters: any) => ({
    type: SET_ASSET_REJECTED_FILTERS,
    assetRejectedFilters
})

const setAssetCancelledFilters = (assetCancelledFilters: any) => ({
    type: SET_ASSET_CANCELLED_FILTERS,
    assetCancelledFilters
})

const setBulkOrderTotalOrderFilters = (bulkOrderTotalOrderFilters: any) => ({
    type: SET_BULK_ORDER_TOTAL_ORDER_FILTERS,
    bulkOrderTotalOrderFilters
})

const setBulkOrderSavedOrderFilters = (bulkOrderSavedOrderFilters: any) => ({
    type: SET_BULK_ORDER_SAVED_ORDER_FILTERS,
    bulkOrderSavedOrderFilters
})

const setBulkOrderPendingApprovalFilters = (bulkOrderPendingApprovalFilters: any) => ({
    type: SET_BULK_ORDER_PENDING_APPROVAL_FILTERS,
    bulkOrderPendingApprovalFilters
})

const setBulkOrderFleetProcessingFilters = (bulkOrderFleetProcessingFilters: any) => ({
    type: SET_BULK_ORDER_FLEET_PROCESSING_FILTERS,
    bulkOrderFleetProcessingFilters
})

const setBulkOrderCompletedFilters = (bulkOrderCompletedFilters: any) => ({
    type: SET_BULK_ORDER_COMPLETED_FILTERS,
    bulkOrderCompletedFilters
})

const setBulkOrderReturnedFilters = (bulkOrderReturnedFilters: any) => ({
    type: SET_BULK_ORDER_RETURNED_FILTERS,
    bulkOrderReturnedFilters
})

const setBulkOrderRejectedFilters = (bulkOrderRejectedFilters: any) => ({
    type: SET_BULK_ORDER_REJECTED_FILTERS,
    bulkOrderRejectedFilters
})
const setAcquisitionCodeMaintenanceFilters = (acquisitionFilters: any) => ({
    type: SET_ACQUISITION_CODE_MAINTENANCE_FILTERS,
    acquisitionFilters
})

const setBulkOrderCancelledFilters = (bulkOrderCancelledFilters: any) => ({
    type: SET_BULK_ORDER_CANCELLED_FILTERS,
    bulkOrderCancelledFilters
})

const setVehicleGridFilters = (vehicleGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS,
    vehicleGridFilters
})

const setMowerGridFilters = (mowerGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS,
    mowerGridFilters
})

const setConstructionEquipmentGridFilters = (constructionEquipmentGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS,
    constructionEquipmentGridFilters
})

const setSnowGridFilters = (snowGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS,
    snowGridFilters
})

const setStandardizedGridFilters = (standardizedGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS,
    standardizedGridFilters
})

const setTrailersGridFilters = (trailersGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS,
    trailersGridFilters
})

const setUtilityVehicleGridFilters = (utilityVehicleGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS,
    utilityVehicleGridFilters
})

const setTreeCareGridFilters = (treeCareGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS,
    treeCareGridFilters
})

const setJobTitlesGridFilters = (jobTitlesGridFilters: any) => ({
    type: SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS,
    jobTitlesGridFilters
})

export default {
    setRequestGridFilters,
    setAssetGridFilters,
    setHomePendingApprovalGridFilters,
    setHomeMyOrdersGridFilters,
    setHomeFleetProcessingGridFilters,
    setHomeAllPendingApprovalGridFilters,
    setBulkOrderGridFilters,
    setCatalogManagementGridFilters,
    setRequestTotalOrderFilters,
    setRequestSavedOrderFilters,
    setRequestPendingApprovalFilters,
    setRequestFleetProcessingFilters,
    setRequestCompletedFilters,
    setRequestReturnedFilters,
    setRequestPendingFleetFilters,
    setRequestRejectedFilters,
    setRequestCancelledFilters,
    setDispositionPenaltyFeesFilters,
    setAssetTotalOrderFilters,
    setAssetSavedOrderFilters,
    setAssetPendingApprovalFilters,
    setAssetFleetProcessingFilters,
    setAssetCompletedFilters,
    setAssetReturnedFilters,
    setAssetPendingFleetFilters,
    setAssetRejectedFilters,
    setAssetCancelledFilters,
    setBulkOrderTotalOrderFilters,
    setBulkOrderSavedOrderFilters,
    setBulkOrderPendingApprovalFilters,
    setBulkOrderFleetProcessingFilters,
    setBulkOrderCompletedFilters,
    setBulkOrderReturnedFilters,
    setBulkOrderRejectedFilters,
    setBulkOrderCancelledFilters,
    setAcquisitionCodeMaintenanceFilters,
    setVehicleGridFilters,
    setMowerGridFilters,
    setConstructionEquipmentGridFilters,
    setSnowGridFilters,
    setStandardizedGridFilters,
    setTrailersGridFilters,
    setUtilityVehicleGridFilters,
    setTreeCareGridFilters,
    setJobTitlesGridFilters
}